import React from "react";
import { Link } from "react-router-dom";

import { ArrowIcon } from "./Icons";

// How it works, in the order it happens. Drawn from the hero line itself:
// "We'll tell you what you can borrow, and who'll lend it. Then we handle
// the paperwork and the chasing."
const STEPS = [
  {
    title: "A free first chat",
    text: "Online, by phone, or in person. No obligation.",
  },
  {
    title: "What you can borrow, and who’ll lend it",
    text: "We compare across the major New Zealand banks and specialist lenders.",
  },
  {
    title: "We handle the paperwork and the chasing",
    text: "From application through to settlement.",
  },
];

const CheckIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </svg>
);

function Hero() {
  return (
    <section className="hero">
      <div className="hero-inner">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="hero-badge-dot" />
            <span>Expert Finance • Auckland & NZ-wide</span>
          </div>

          <h1 className="hero-title">
            Let’s get your{" "}
            <span className="hero-highlight">mortgage & finance</span> sorted.
          </h1>

          <p className="hero-punchline">
            We’ll tell you what you can borrow, and who’ll lend it. Then we
            handle the paperwork and the chasing.
          </p>

          <div className="hero-actions">
            <Link to="/contact" className="pill-btn pill-btn-primary">
              Book a free consultation
              <ArrowIcon />
            </Link>
            <Link to="/calculator" className="pill-btn pill-btn-ghost">
              Try our loan calculator
            </Link>
          </div>

          <ul className="hero-usp-row">
            <li>
              <CheckIcon />
              Access to major New Zealand banks & lenders
            </li>
            <li>
              <CheckIcon />
              Online, phone, or in-person appointments
            </li>
          </ul>
        </div>

        <aside className="hero-steps" aria-label="How it works">
          <p className="hero-steps-title">How it works</p>
          <ol>
            {STEPS.map((step, index) => (
              <li key={step.title} className="hero-step">
                <span className="hero-step-number">{index + 1}</span>
                <span className="hero-step-body">
                  <strong>{step.title}</strong>
                  <span>{step.text}</span>
                </span>
              </li>
            ))}
          </ol>
        </aside>
      </div>
    </section>
  );
}

export default Hero;
